import React from "react";
import assets from "../../../shared/constants/assetVariables";

const faqList = [
  {
    id: 1,
    question: "What is CSRD and who needs to comply?",
    answer:
      "The Corporate Sustainability Reporting Directive (CSRD) is a new EU regulation requiring companies to report their sustainability performance in alignment with the European Sustainability Reporting Standards (ESRS). It applies to large companies, listed SMEs, and non-EU companies with significant EU operations.",
  },
  {
    id: 2,
    question: "How does Updapt help with CSRD compliance?",
    answer: "Updapt automates CSRD compliance through:",
    answerList: [
      "AI-powered Double Materiality Assessment",
      "Automated ESG Data Collection & Reporting",
      "XBRL-Compliant Report Generation",
      "Real-Time Compliance Tracking & Peer Benchmarking",
    ],
  },
  {
    id: 3,
    question: "What is Double Materiality, and why is it important?",
    answer: "Double materiality ensures companies report on:",
    answerList: [
      "Financial Materiality – ESG factors that impact business performance.",
      "Impact Materiality – The company’s effect on people and the planet. Updapt’s AI-powered Double Materiality Assessment streamlines this process, ensuring full CSRD compliance.",
    ],
  },
  {
    id: 4,
    question: "Can Updapt integrate with my existing ESG data sources?",
    answer:
      "Yes, Updapt seamlessly integrates with multiple ESG frameworks and data sources (SASB, BRSR, IFRS, TCFD, etc.), allowing organizations to reuse existing sustainability data for efficient reporting.",
  },
  {
    id: 5,
    question: "How does Updapt ensure audit-ready CSRD reports?",
    answer: "Updapt provides:",
    answerList: [
      "Automated Report Generation aligned with ESRS standards",
      "Version Control & Compliance Tracking for transparency",
      "AI-Powered IRO (Impact, Risk & Opportunity) Generation",
    ],
  },
  {
    id: 6,
    question: "What reporting formats does Updapt support?",
    answer: "Updapt generates CSRD-compliant reports in multiple formats:",
    answerList: [
      "XBRL (machine-readable format)",
      "PDF (narrative reporting)",
      "HTML (for online reporting)",
    ],
  },
  {
    id: 7,
    question: "How does Updapt handle compliance tracking?",
    answer: "Our Real-Time CSRD Dashboard provides:",
    answerList: [
      "Live monitoring of disclosure completeness",
      "Materiality risk assessment & compliance validation",
      "Industry benchmarking & peer comparisons",
    ],
  },
  {
    id: 8,
    question: "How can I get started with Updapt’s CSRD Compliance Solution?",
    answer:
      "It’s simple. Request a free demo or get started today to streamline your sustainability reporting and stay ahead of CSRD regulations.",
  },
];
function Section_11({ activeIndex, toggleAccordion }) {
  return (
    <section className="csrd-landing-page-section-11-container">
      <div className="csrd-landing-page-section-11-inner-container">
        <div className="section-11-header">FREQUENTLY ASKED QUESTIONS</div>
        <div className="section-11-content-container">
          <div className="section-11-left-container">
            <div className="faq-image-container">
              <img
                src={assets.images.faqImage1}
                alt="faq-image_1"
                className="faq-image-1"
                width="90%"
              />
            </div>
          </div>
          <div className="section-11-right-container">
            <img
              src={assets.images.faqImage2}
              alt="faq-image_2"
              className="faq-image-2"
              size="20%"
            />
            {faqList.map((item) => (
              <div key={item.id}>
                <button
                  className={`accordion accordion${item.id} ${
                    activeIndex === item.id ? "active" : ""
                  }`}
                  onClick={() => toggleAccordion(item.id)}
                >
                  <div className="question">{item.question}</div>
                  <div className="expand-icon">
                    {activeIndex === item.id ? (
                      <span>
                        <img src={assets.icons.accord_minus} />
                      </span>
                    ) : (
                      <span>
                        <img src={assets.icons.accord_plus} />
                      </span>
                    )}
                  </div>
                </button>
                <div
                  className={`panel panel${item.id}`}
                  style={{
                    maxHeight: activeIndex === item.id ? "fit-content" : "0px",
                    overflow: "hidden",
                    transition: "max-height 01s ease",
                  }}
                >
                  <p
                    className="answer"
                    style={!item?.answerList ? { paddingBottom: "10px" } : {}}
                  >
                    {item.answer}
                  </p>
                  {item.answerList && (
                    <ul className="answer-list">
                      {item.answerList.map((listItem) => (
                        <li key={listItem}>{listItem}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section_11;
